import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h1","key":"svg-0"}],["path",{"d":"M12 3v1","key":"svg-1"}],["path",{"d":"M20 12h1","key":"svg-2"}],["path",{"d":"M5.6 5.6l.7 .7","key":"svg-3"}],["path",{"d":"M18.4 5.6l-.7 .7","key":"svg-4"}],["path",{"d":"M8 12a4 4 0 1 1 8 0","key":"svg-5"}],["path",{"d":"M3 16h18","key":"svg-6"}],["path",{"d":"M3 20h18","key":"svg-7"}]]

const IconHaze = createReactComponent('outline', 'haze', 'Haze', __iconNode);

export default IconHaze;